import { BooleanInput, Edit, FormDataConsumer, SimpleForm, TextInput, useNotify } from 'react-admin';
import AddToLokaliseButton from '../../Components/AddToLokaliseButton';
import { useNavigate } from 'react-router-dom';

const RequestTypeTemplatesEdit = () => {
  const navigate = useNavigate();
  const notify = useNotify();
  return (
    <Edit
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify('Saved');
          navigate(-1);
        }
      }}
    >
      <SimpleForm>
        <TextInput disabled source="uuid" label="UUID" />
        <TextInput disabled source="country" label="Country" />
        <TextInput disabled source="name" label="Name" />
        <FormDataConsumer>{({ formData }) => <AddToLokaliseButton translationKey={formData.name} />}</FormDataConsumer>
        <BooleanInput source="active" label="Active" />
      </SimpleForm>
    </Edit>
  );
};

export default RequestTypeTemplatesEdit;
